var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const Svg5White = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "87px",
    viewBox: "0 0 64 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4,0.9 L43.4,0.9 C43.3,0.9 43.1,1 43.1,1.2 L43.1,7.8 C43.1,7.9 43.2,8.1 43.4,8.1 L51.4,8.1 L42.6,16.9 C38.1,13.4 32.5,11.3 26.4,11.3 C12,11.3 0.2,23.1 0.2,37.5 C0.2,50.8 10.2,61.8 23,63.5 L23,71.2 L15.1,71.2 C15,71.2 14.8,71.3 14.8,71.5 L14.8,78.6 C14.8,78.7 14.9,78.9 15.1,78.9 L23,78.9 L23,86.4 C23,86.5 23.1,86.7 23.3,86.7 L30.4,86.7 C30.5,86.7 30.7,86.6 30.7,86.4 L30.7,78.9 L38.6,78.9 C38.7,78.9 38.9,78.8 38.9,78.6 L38.9,71.5 C38.9,71.4 38.8,71.2 38.6,71.2 L30.7,71.2 L30.7,63.4 C43.1,61.4 52.6,50.6 52.6,37.6 C52.6,32 50.8,26.8 47.8,22.5 L56.5,13.8 L56.5,21.2 C56.5,21.3 56.6,21.5 56.8,21.5 L63.4,21.5 C63.5,21.5 63.7,21.4 63.7,21.2 L63.7,1.2 C63.7,1 63.5,0.9 63.4,0.9 M26.4,56.8 C15.8,56.8 7.1,48.1 7.1,37.5 C7.1,26.9 15.7,18.2 26.4,18.2 C37,18.2 45.7,26.8 45.7,37.5 C45.7,48.1 37,56.8 26.4,56.8",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,29.6 L15,29.6 C14.9,29.6 14.7,29.7 14.7,29.8 L14.7,35.5 C14.7,35.6 14.8,35.7 15,35.7 L38.4,35.7 C38.5,35.7 38.7,35.6 38.7,35.5 L38.7,29.8 C38.6,29.7 38.5,29.6 38.3,29.6 M38.3,39.7 L15,39.7 C14.9,39.7 14.7,39.8 14.7,39.9 L14.7,45.6 C14.7,45.7 14.8,45.8 15,45.8 L38.4,45.8 C38.5,45.8 38.7,45.7 38.7,45.6 L38.7,39.9 C38.6,39.8 38.5,39.7 38.3,39.7",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg5White);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/5_white.486bd9dc61e02210392c7142a82f9eb1.svg";